import React from "react";
import { TicketEventFragment } from "@graphql";
import { InlineEditor } from "@components/InlineEditor/InlineEditor";
import { TicketEventFloatingMenu } from "../TicketEventFloatingMenu/TicketEventFloatingMenu";
import { Event } from "../../Event/Event";
import TicketEventLogStore from "../TicketEventLogStore";
import { StyledHtml } from "@common/StyledHtml";

type Props = {
  item: TicketEventFragment;
  store: TicketEventLogStore;
};

type State = {
  isEditing: boolean;
};

export class TicketEvent extends React.Component<Props, State> {
  state: State = {
    isEditing: false
  };

  startEdit = () => this.setState({ isEditing: true });
  finishEdit = () => this.setState({ isEditing: false });

  update = (desc: string) => {
    const { item, store } = this.props;
    return store.updateEvent(item._id, desc).then(this.finishEdit);
  };

  render() {
    const { item, store } = this.props;
    const { isEditing } = this.state;

    const menu = (
      <TicketEventFloatingMenu
        event={item}
        onEdit={this.startEdit}
        onDelete={() => store.deleteEvent(item._id)}
      />
    );

    return (
      <Event key={this.props.item._id} item={item} floatingMenu={menu}>
        <>
          <InlineEditor
            readOnlyRenderer={() => <StyledHtml>{item.DescriptionHtml}</StyledHtml>}
            initialValue={item.Description}
            onSubmit={this.update}
            isEditing={isEditing}
            onCancel={this.finishEdit}
          />
        </>
      </Event>
    );
  }
}

export default TicketEvent;
